<template>
  <span
    v-if="first"
    class="validation-message"
  >
    <transition name="fade">
      <span
        v-if="showText"
        class="lh16 flex middle-xs mt10"
        @click="hideText"
      >
        <span class="validation-text c-error fs16 regular italic">
          {{ first.text }}
        </span>
      </span>
    </transition>
  </span>
</template>
<script>
export default {
  props: {
    validations: {
      type: Array,
      default: () => []
    },
    showText: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    // First condition that failed
    first () {
      return this.validations.find(validation => validation.condition)
    }
  },
  methods: {
    hideText () {
      this.showText = false
    }
  }
}
</script>
